<div class="card shadow">
  <div class="card-body">
    <app-table-header-template [searchOptions]="CardsSearchOptions">
      <ng-container filter>
        <app-cards-filter
          (query)="update($event)"
          (filterApplied)="onFilterApplied($event)"></app-cards-filter>
      </ng-container>
      <ng-container buttons>
        <div class="row align-items-center">
          <div class="col-auto">
            <div class="reduce-size-90">
              <app-toggle-switch
                [class]="'table-switch'"
                [hideIcon]="true"
                [initialValue]="!showHideRemoved()"
                [label]="'Show all'"
                [disabled]="filterApplied()"
                [id]="'hideInactiveCategoriesSwitch'"
                (switchChange)="onToggleHideRemoved()">
              </app-toggle-switch>
            </div>
          </div>
          <div class="col-auto">
            <button
              (click)="issueCard()"
              class="btn btn-sm btn-primary"
              id="issueCardModalBtn">
              Issue new card
            </button>
          </div>
        </div>
      </ng-container>
    </app-table-header-template>

    <app-table
      [columns]="columns"
      [getDataCallback]="getData"
      class="table-employee-cards"
      emptyMessage="Your employee cards will appear here.">
      <ng-template
        #firstName
        let-row="row"
        let-value="value">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-0">
            <app-avatar
              [firstName]="row.holder.first_name"
              [lastName]="row.holder.last_name"></app-avatar>
          </div>
          <div class="col">{{ value }}</div>
        </div>
      </ng-template>

      <ng-template
        #expiryDate
        let-value="value">
        {{ value | date: 'MM/yyyy' | emptyIndicator }}
      </ng-template>

      <ng-template
        #cardStatus
        let-value="value">
        <app-status-badge
          [value]="value"
          [department]="statusBadgeDepartments.CARDS"></app-status-badge>
      </ng-template>

      <ng-template
        #balance
        let-value="value">
        {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
      </ng-template>

      <ng-template
        #actions
        let-row="row">
        <div>
          <button
            (click)="onViewCard(row.id)"
            class="btn-action">
            <i class="iconoir-nav-arrow-right"></i>
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet />
</div>
